import {Link} from "react-router-dom";
import {images} from "../../../assets/images";
import {useTranslation} from "react-i18next";

export const GdprPolicy = () => {
    const {t} = useTranslation('', {keyPrefix: 'GdprPolicy'});
    return (
        <div className={`up-wrapper`}>
            <header id="up-header" style={{'width': '100%'}} className="up-header">
                <div className="up-headercontent">
                    <strong className="up-logo">
                        <Link to="/home">
                            <img src={images.Logo} alt="Logo Image"/>
                        </Link>
                    </strong>
                </div>
            </header>
            <main className="up-main">
                <div className="up-termandconditionpage">
                    <div className="up-themebox">
                        <div>
                            <h4><strong>UP2D8 — Privacybeleid</strong></h4>
                            <p>Bij UP2D8 hechten wij veel belang aan de bescherming van jouw persoonsgegevens. Dit
                                privacybeleid legt uit welke gegevens wij verzamelen, hoe wij deze gebruiken, hoe lang
                                we ze bewaren en welke rechten je hebt. UP2D8 handelt in overeenstemming met de Algemene
                                Verordening Gegevensbescherming (AVG/GDPR).</p>
                            <p></p>
                            <h4><strong>1. Wie is verantwoordelijk voor jouw gegevens?</strong></h4>
                            <p>De verwerkingsverantwoordelijke is <strong>Rovata</strong><strong> BV</strong>,
                                ondernemingsnummer <strong>BE 1024.711.166</strong>, Aartrijkestraat 152, 8820 Torhout,
                                België. Voor vragen kan je ons bereiken via .</p>
                            <p></p>
                            <h4><strong>2. Welke gegevens verzamelen wij?</strong></h4>
                            <p>Wij verzamelen en verwerken enkel de gegevens die nodig zijn voor het gebruik van het
                                UP2D8-platform:</p>
                            <p style={{marginLeft: '20px'}}>• <strong>Account- en profielgegevens</strong>: naam,
                                e-mailadres, adres, geboortedatum, links naar sociale media, profielafbeelding.</p>
                            <p style={{marginLeft: '20px'}}>• <strong>Communicatiegegevens</strong>: berichten en
                                interacties met organisaties. Berichten blijven privé en worden niet ingezien door
                                UP2D8.</p>
                            <p style={{marginLeft: '20px'}}>• <strong>Gebruiksgegevens</strong>: o.a. wie een post
                                bekijkt en wanneer je de app voor het laatst hebt geopend.</p>
                            <p style={{marginLeft: '20px'}}>• <strong>Technische gegevens</strong>: beperkte informatie
                                nodig voor de werking van de app (zoals IP-adres en apparaat-informatie).</p>
                            <p>Wij verzamelen géén betaalgegevens, omdat UP2D8 geen premium of betaalde diensten
                                aanbiedt.</p>
                            <p></p>
                            <h4><strong>3. Waarvoor gebruiken wij jouw gegevens?</strong></h4>
                            <p>Wij gebruiken jouw persoonsgegevens uitsluitend voor de volgende doeleinden:</p>
                            <p style={{marginLeft: '20px'}}>• Het aanbieden en verbeteren van onze diensten.</p>
                            <p style={{marginLeft: '20px'}}>• Het mogelijk maken dat je organisaties kunt volgen en door
                                hen herkend kunt worden.</p>
                            <p style={{marginLeft: '20px'}}>• Het garanderen van de veiligheid en goede werking van ons
                                platform.</p>
                            <p style={{marginLeft: '20px'}}>• Het versturen van serviceberichten, nieuwsbrieven en
                                informatie over onze diensten.</p>
                            <p style={{marginLeft: '20px'}}>• Het uitvoeren van onderzoek om onze diensten te
                                verbeteren.</p>
                            <p style={{marginLeft: '20px'}}>• Het voorkomen en aanpakken van fraude, misbruik of
                                technische problemen.</p>
                            <p>Wij gebruiken jouw gegevens nooit voor andere doeleinden zonder je vooraf te informeren
                                of je toestemming te vragen.</p>
                            <p></p>
                            <h4><strong>4. Worden gegevens gedeeld met derden?</strong></h4>
                            <p style={{marginLeft: '20px'}}>• Gegevens worden <strong>niet verkocht of doorgegeven aan
                                derden</strong> voor commerciële doeleinden.</p>
                            <p style={{marginLeft: '20px'}}>• Alleen wanneer jij zelf besluit een organisatie te volgen,
                                wordt je naam gedeeld met die organisatie zodat zij jou als volger kunnen
                                accepteren.</p>
                            <p style={{marginLeft: '20px'}}>• Wij maken gebruik van externe dienstverleners voor hosting
                                en opslag, zoals <strong>AWS</strong> en <strong>MongoDB</strong>.</p>
                            <p></p>
                            <h4><strong>5. Bewaartermijnen</strong></h4>
                            <p>We bewaren jouw gegevens zo lang als nodig is om onze diensten aan te bieden en om te
                                voldoen aan wettelijke verplichtingen. Wanneer je je account verwijdert, verwijderen of
                                anonimiseren wij je gegevens binnen een redelijke termijn, tenzij de wet ons verplicht
                                om deze langer te bewaren.</p>
                            <p></p>
                            <h4><strong>6. Jouw rechten</strong></h4>
                            <p>Als gebruiker binnen de EU heb je de volgende rechten:</p>
                            <p style={{marginLeft: '20px'}}>• Recht op inzage van jouw gegevens.</p>
                            <p style={{marginLeft: '20px'}}>• Recht op correctie van onjuiste gegevens.</p>
                            <p style={{marginLeft: '20px'}}>• Recht op verwijdering van jouw gegevens (“recht om
                                vergeten te worden”).</p>
                            <p style={{marginLeft: '20px'}}>• Recht op beperking van de verwerking.</p>
                            <p style={{marginLeft: '20px'}}>• Recht op overdraagbaarheid van gegevens.</p>
                            <p style={{marginLeft: '20px'}}>• Recht om bezwaar te maken tegen verwerking, met name bij
                                direct marketing.</p>
                            <p>Je kan deze rechten uitoefenen door een e-mail te sturen naar met een bewijs van je
                                identiteit. Dit doen we om misbruik of ongeoorloofde toegang te voorkomen.</p>
                            <p></p>
                            <h4><strong>7. Beveiliging</strong></h4>
                            <p>Wij nemen passende technische en organisatorische maatregelen om jouw gegevens te
                                beschermen tegen verlies, misbruik en ongeautoriseerde toegang. Toch kunnen wij geen
                                absolute veiligheid garanderen.</p>
                            <p></p>
                            <h4><strong>8. Minderjarigen</strong></h4>
                            <p>Onze diensten zijn bedoeld voor personen vanaf de leeftijd waarop zij wettelijk
                                zelfstandig toestemming mogen geven (16 jaar in België). Indien je jonger bent, mag je
                                het platform enkel gebruiken met toestemming van een ouder of voogd.</p>
                            <p></p>
                            <h4><strong>9. Wijzigingen aan dit beleid</strong></h4>
                            <p>Wij kunnen dit privacybeleid van tijd tot tijd aanpassen. Bij belangrijke wijzigingen
                                brengen wij je op de hoogte via e-mail of een melding in de app. De meest recente versie
                                is altijd beschikbaar op onze website.</p>
                            <p></p>
                            <h4><strong>10. Klachten</strong></h4>
                            <p>Indien je klachten hebt over de manier waarop wij met je gegevens omgaan, kan je ons
                                contacteren via . Je hebt ook het recht een klacht in te dienen bij
                                de <strong>Gegevensbeschermingsautoriteit</strong> (Drukpersstraat 35, 1000 Brussel).
                            </p>
                            <p></p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}